// 여러 백엔드 응답 스펙 차이를 화면 공통 일정 모델로 맞춘다.
export function normalizeScheduleCategory(rawCategory) {
  const normalized = String(rawCategory || "").trim().toUpperCase();

  if (normalized === "MATCH") {
    return "MATCH";
  }
  if (normalized === "MEETING") {
    return "MEETING";
  }
  return "TRAINING";
}

export function toNullableCoordinate(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function normalizeAttendanceByUserId(schedule) {
  const mapFromObject = schedule?.attendanceByUserId;
  if (mapFromObject && typeof mapFromObject === "object") {
    return Object.fromEntries(
      Object.entries(mapFromObject)
        .map(([userId, attendance]) => {
          const normalizedUserId = String(userId || "").trim();
          if (!normalizedUserId) {
            return null;
          }
          if (attendance && typeof attendance === "object") {
            return [
              normalizedUserId,
              {
                checkedInAt: attendance.checkedInAt || attendance.checkInAt || null,
                distanceMeters:
                  attendance.distanceMeters != null
                    ? Number(attendance.distanceMeters)
                    : null,
              },
            ];
          }
          return [normalizedUserId, { checkedInAt: null, distanceMeters: null }];
        })
        .filter(Boolean),
    );
  }

  const attendanceArray = Array.isArray(schedule?.attendances)
    ? schedule.attendances
    : Array.isArray(schedule?.attendanceList)
      ? schedule.attendanceList
      : [];
  if (attendanceArray.length > 0) {
    return Object.fromEntries(
      attendanceArray
        .map((attendance) => {
          const userId =
            attendance?.userId ??
            attendance?.memberUserId ??
            attendance?.id;
          const normalizedUserId = String(userId || "").trim();
          if (!normalizedUserId) {
            return null;
          }
          return [
            normalizedUserId,
            {
              checkedInAt: attendance?.checkedInAt || attendance?.checkInAt || null,
              distanceMeters:
                attendance?.distanceMeters != null
                  ? Number(attendance.distanceMeters)
                  : null,
            },
          ];
        })
        .filter(Boolean),
    );
  }

  const attendanceUserIds = Array.isArray(schedule?.attendanceUserIds)
    ? schedule.attendanceUserIds
    : Array.isArray(schedule?.checkedInUserIds)
      ? schedule.checkedInUserIds
      : [];
  if (attendanceUserIds.length > 0) {
    return Object.fromEntries(
      attendanceUserIds
        .map((userId) => String(userId || "").trim())
        .filter(Boolean)
        .map((userId) => [userId, { checkedInAt: null, distanceMeters: null }]),
    );
  }

  return {};
}

// 일정 목록/상세 응답을 화면에서 재사용 가능한 단일 구조로 정리한다.
export function normalizeSchedulePayloadItem(schedule) {
  const startsAt =
    schedule?.startsAt || schedule?.startAt || schedule?.startDateTime;
  const endsAt =
    schedule?.endsAt || schedule?.endAt || schedule?.endDateTime || startsAt;
  const voteStartAt =
    schedule?.voteStartAt ||
    schedule?.voteStartsAt ||
    schedule?.voteStartDateTime ||
    schedule?.createdAt ||
    null;
  const voteEndAt = schedule?.voteEndAt || schedule?.voteEndsAt || endsAt;
  const rawCategory =
    schedule?.category ??
    schedule?.scheduleCategory ??
    schedule?.scheduleType ??
    schedule?.type ??
    schedule?.eventType;

  return {
    id: schedule?.id ?? schedule?.scheduleId,
    teamId: schedule?.teamId ?? schedule?.workspaceId ?? null,
    teamName: schedule?.teamName || schedule?.workspaceName || "",
    teamLogoUrl: schedule?.teamLogoUrl || schedule?.logoUrl || "",
    title:
      schedule?.title ||
      schedule?.name ||
      schedule?.scheduleTitle ||
      "제목 없음",
    category: normalizeScheduleCategory(rawCategory),
    startsAt,
    endsAt,
    venueName: schedule?.venueName || schedule?.stadiumName || "-",
    address: schedule?.address || schedule?.venueAddress || "-",
    detailAddress:
      schedule?.detailAddress ||
      schedule?.addressDetail ||
      schedule?.addressLine2 ||
      "",
    latitude: toNullableCoordinate(
      schedule?.latitude ?? schedule?.lat ?? schedule?.locationLatitude,
    ),
    longitude: toNullableCoordinate(
      schedule?.longitude ??
        schedule?.lng ??
        schedule?.lon ??
        schedule?.locationLongitude,
    ),
    voteStartAt,
    voteEndAt,
    voteReminderLastSentAt:
      schedule?.voteReminderLastSentAt ||
      schedule?.lastVoteReminderSentAt ||
      null,
    voteReminderLastSentByUserId:
      schedule?.voteReminderLastSentByUserId ||
      schedule?.lastVoteReminderSentByUserId ||
      null,
    attendanceByUserId: normalizeAttendanceByUserId(schedule),
    description: schedule?.description || schedule?.memo || "",
    votes:
      schedule?.votes && typeof schedule.votes === "object"
        ? schedule.votes
        : {},
  };
}

// 페이지네이션/래핑 구조가 달라도 배열만 안정적으로 뽑아낸다.
export function extractScheduleItems(responseData) {
  if (Array.isArray(responseData)) {
    return responseData;
  }
  if (Array.isArray(responseData?.content)) {
    return responseData.content;
  }
  if (Array.isArray(responseData?.items)) {
    return responseData.items;
  }
  if (Array.isArray(responseData?.schedules)) {
    return responseData.schedules;
  }
  if (Array.isArray(responseData?.data)) {
    return responseData.data;
  }
  return [];
}
